import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { avantorAnimations } from '@core/animations/animations';
import { AppService } from '@core/services/app/app-api';
import { SoftwareService } from '@core/services/download-center/software/software-api';
import { OrgAndStockroomService } from '@core/services/org-and-stockroom/org-and-stockroom-api';
import { ToastService } from '@core/services/toast-api';
import { TranslatePipe } from '@ngx-translate/core';
import saveAs from 'file-saver';
import { Subject } from 'rxjs';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';
const datepipe: DatePipe = new DatePipe('en-US');
@Component({
  selector: 'app-user-manual-panel',
  templateUrl: './user-manual-panel.html',
  styleUrls: ['./user-manual-panel.scss'],
  animations: [avantorAnimations],
  standalone: true,
  providers: [TranslatePipe],
  imports: [CommonModule, SharedModule, FormsModule, MaterialsModule],
})
export class UserManualPanelComponent implements OnInit {
  @ViewChild('pdfViewerContainer', { read: ViewContainerRef })
  pdfViewerContainer!: ViewContainerRef;
  componentRef: any;
  isLoading: boolean = true;
  showSearchPanel: boolean = false;
  private destroy$: Subject<void> = new Subject();
  @ViewChild('PdfViewerComponent') pdfComponent!: any; // Use 'any' type for dynamic import
  searchText: string = "";
  pdfQuery = '';
  pdfPage = 1;

  constructor(
    private router: Router,
    // private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private softwareService: SoftwareService,
    private toastService: ToastService,
    private translatePipe: TranslatePipe,
    public appService: AppService,
    public orgAndStockroomService: OrgAndStockroomService

  ) {
  }
  ngOnInit(): void {
    this.loadPdfViewerModule();
    this.appService.resonsiveUserManualPdfId.subscribe((id: any) => {
      console.log('this.userManualqwewewq', id)
      this.userManual = id;
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }



  private loadPdfViewerModule() {
    import('ng2-pdf-viewer').then((module) => {
      // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      //   module.PdfViewerComponent
      // );

      this.componentRef = this.pdfViewerContainer.createComponent(
        module.PdfViewerComponent,
        {
          injector: this.injector
        }
      );
      this.componentRef.instance.src = this.appService.pdfSrc;
      this.componentRef.instance.renderText = true;
      this.componentRef.instance.originalSize = false;
      this.componentRef.instance.zoom = 1;

      this.componentRef.instance.afterLoadComplete.subscribe((event: any) => {
        this.afterLoadComplete(event);
      });
    });
  }

  scrollToPage(pageNumber: any) {
    if (this.componentRef) {
      this.componentRef.instance.pdfViewer.scrollPageIntoView({
        pageNumber: Number(pageNumber),
      })
    }
  }


  /**---------------------------------------------
  * @CLOSE_PANEL
  * Close panel event
  */
  @Input() openPanel: boolean = false;
  @Input() userManual: any;
  @Output() closePanel = new EventEmitter<void>();



  searchQueryChanged(newQuery: string) {
    const type = newQuery !== this.pdfQuery ? '' : 'again';
    this.pdfQuery = newQuery;
  }


  afterLoadComplete(pdf: any) { // Use 'any' type for dynamic import
    // Your logic after the PDF has been loaded completely
    setTimeout(() => {
      // this.scrollToPage(this.pdfPage);
      if (this.router.url) {
        let page = this.router.url;
        this.goToSection(page);
      }
      // Now scroll to page 10
    }, 500);

  }

  close() {
    this.closePanel.emit();
  }

  goToSection(page: string) {
    if (page == '/app') {
      this.pdfPage = 23;
      this.scrollToPage(this.pdfPage)
    } else if (page.includes('replenish-stock')) {
      this.pdfPage = 32;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('receive-stock')) {
      this.pdfPage = 47;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('create-barcodes')) {
      this.pdfPage = 60;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('stock-correction')) {
      this.pdfPage = 71;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('manage-stockroom')) {
      this.pdfPage = 75;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('vendor-maintenance')) {
      this.pdfPage = 99;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('product-maintenance')) {
      this.pdfPage = 105;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('consume-stock')) {
      this.pdfPage = 27;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('article-activity-log')) {
      this.pdfPage = 137;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('stockroom-activity-log')) {
      this.pdfPage = 138;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('reporting')) {
      this.pdfPage = 141;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('download-center')) {
      this.pdfPage = 149;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('user-maintenance')) {
      this.pdfPage = 126;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('cost-center-maintenance')) {
      this.pdfPage = 88;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('department-maintenance')) {
      this.pdfPage = 93;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('reference-codes')) {
      this.pdfPage = 79;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('export-import-stockroom')) {
      this.pdfPage = 77;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('approval')) {
      this.pdfPage = 56;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('help')) {
      this.pdfPage = 8;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('scanner-replenish')) {
      this.pdfPage = 45;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('stock-transfer')) {
      this.pdfPage = 124;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('reason-code-maintenance')) {
      this.pdfPage = 98;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('location-maintenance')) {
      this.pdfPage = 87;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('account-settings')) {
      this.pdfPage = 12;
      this.scrollToPage(this.pdfPage)
    }

    else if (page.includes('requests')) {
      this.pdfPage = 139;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('orders')) {
      this.pdfPage = 139;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('products')) {
      this.pdfPage = 140;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('track-orders')) {
      this.pdfPage = 140;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('return-stock')) {
      this.pdfPage = 59;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('communications')) {
      this.pdfPage = 16;
      this.scrollToPage(this.pdfPage)
    }
    else {
      this.pdfPage = 1;
      this.scrollToPage(this.pdfPage)
    }


  }

  downloadUserManual() {
    const softwareId = this.userManual;
    const fileName = this.translatePipe.transform('ime.usermanual.link.label');
    this.softwareService.downloadSoftware(softwareId).subscribe(
      res => {
        if (res && res.body) {
          saveAs(res.body, `${fileName}.${'pdf'}`);
          this.toastService.show(
            'success',
            this.translatePipe.transform('ime.download.succesful'),
            this.translatePipe.transform('ime.file.has.been.downloaded.succesfully'),
            false,
            3000
          );
        } else {
          this.toastService.show(
            'error',
            this.translatePipe.transform('ime.download.failed'),
            this.translatePipe.transform('invalid.file.delete.msg'),
            false,
            3000
          );
        }
      },
      error => {
        this.toastService.show(
          'error',
          this.translatePipe.transform('ime.download.failed'),
          this.translatePipe.transform('invalid.file.delete.msg'),
          false,
          3000
        );
      }
    );
  }


}